import { mountAllIslands, mountReactIsland } from "./mount";
import { createElement } from "react";
import BillingStopCards from "./orders/BillingStopCards";
import BillingFilePreviews from "./orders/BillingFilePreviews";
import NumberStepper from "./components/NumberStepper/NumberStepper";

const registry = {
  "billing-stop-cards": BillingStopCards,
  "billing-file-previews": BillingFilePreviews,
};

document.addEventListener("DOMContentLoaded", () => {
  mountAllIslands(registry);
});

document.addEventListener("htmx:afterSwap", () => {
  mountAllIslands(registry);
});

window.reactIslands = {
  mount: mountReactIsland,
  rerender: (root, Component, props) =>
    root.render(createElement(Component, props)),
  registry,
  components: { NumberStepper },
};
